
import React, {Component} from 'react';
import {Button,ButtonToolbar,DropdownButton,MenuItem,Nav,NavItem,Panel,Row,Col,FormControl,FormGroup,InputGroup} from 'react-bootstrap'
import FontAwsome from 'react-fontawesome'
import {Box} from 'reactjs-admin-lte'
import SWTWageDataGrid from './SWTWageDataGrid'
import SWTPartDataGrid from './SWTPartDataGrid'
import WorkdocStore from '../../stores/WorkdocStore'
import {Checkbox} from 'react-icheck'
import ConfirmPopup from '../../component/element/ConfirmPopup'
import SWTStockOutPopup from './SWTStockOutPopup';
import QuotationDocModal from '../qo/QuotationDocModal'

import Moment from 'moment';

class SWTWorkDocDamage extends Component {

  constructor(...args){
    super(...args)
    this.state = {loading:true,errorShow:false,showNewDoc:false,docName:'',showWage:true,program:null,activeTab:0,presentTab:0,history:[],
    damageCfg:{program_visible:false,wage_quantity_visible:false,check_visible:false,part_cost_per_unit_visible:false,discount_visible:false,part_first:false}, showStockOut:false,
    dataStockOut:[], dataPartlist:[], dataWagelist:[], displayBtnStockOutView: "none", btnDisabled: false, discountPart:[0,''], discountWage:[0,''], curDiscountPart:[0,''], curDiscountWage:[0,''], checkDiscount:false, displayDiscount:"none",
    discount_part:0, discount_wage:0, discountShow:false,showQo:false,fileId:'',fileName:''
    }
  }

  componentDidMount(){
    this.loadData()
  }

  setPartList(partList){
    let data = partList.map((item,index)=>{
      // let amount = item.price_per_unit * item.quantity
      return {bfId:item.bf_work_damage_id,rowNo:item.seq,itemnum:item.itemnum,productCode:item.productcode,
        detail:item.detail,quantity:item.quantity,costPerUnit:item.cost_per_unit,pricePerUnit:item.price_per_unit,
        discountPercent:item.discount_percent,discountAmount:item.discount_amount,amount:item.amount,
        exportStock:item.export_stock_flag,exportQuantity:item.export_quantity,partFrom:item.part_from}
    })
    return data
  }

  setWageList(wageList){    
    let data = wageList.map((item,index)=>{
      // let amount = item.price_per_unit * item.quantity
      return {bfId:item.bf_work_damage_id,rowNo:item.seq,itemcode:item.itemcode,servicecode:item.servicecode,
        detail:item.detail,quantity:item.quantity,pricePerUnit:item.price_per_unit,amount:item.amount,
        discountPercent:item.discount_percent,discountAmount:item.discount_amount}
    })
    return data
  }

  loadData(){
    
    let {displayDiscount,checkDiscount,discountWage,discountPart} = this.state
    WorkdocStore.loadWorkdocFixingList(this.props.workNo,(result)=>{
       let history = (typeof result.data.history !=='undefined')?result.data.history:[]
       
       let damageCfg = (result.data.damage_config==null)?{program_visible:false,wage_quantity_visible:false,part_cost_per_unit_visible:false,discount_visible:false,part_first:false,quotation_menu_visible:false}:result.data.damage_config
       // console.log('damageCfg',damageCfg)
       let presentTab = 0
       history.map((item,index)=>{
          if(item.work_no===this.props.workNo){
            presentTab = index
          }
       })

      history.push({
        work_no:"",
        work_date:"",
        mileage:"",
        htmlContent:""
      })

      if(result.data.quotation_file_id!==undefined && result.data.quotation_file_id!==''){
        this.setState({fileId:result.data.quotation_file_id,fileName:result.data.quotation_file_name})
      }

      if (result.data.discount_part>0||result.data.discount_wage>0) {
        displayDiscount = ""
        checkDiscount = true
        discountWage[1] = result.data.discount_wage
        discountPart[1] = result.data.discount_part
      }

      this.setState({discountWage:discountWage,discountPart:discountPart,checkDiscount:checkDiscount,displayDiscount:displayDiscount,discount_part:result.data.discount_part,discount_wage:result.data.discount_wage,dataPartlist:result.data.partlist,dataWagelist:result.data.wagelist,loading:false,program:result.data.program,activeTab:presentTab,presentTab:presentTab,damageCfg:damageCfg,history:history}) 
      this.refs.wageDataGrid.setWageList(result.data.wagelist)
      this.refs.partDataGrid.setPartList(result.data.partlist)
     
    })
  }

  onSaveClick(){
    let {program,discountPart,discountWage,displayDiscount,checkDiscount} = this.state
    let wageList = this.refs.wageDataGrid.getWageList()
    let partList = this.refs.partDataGrid.getPartList()
    let that = this
    WorkdocStore.saveWorkdocFixingList(this.props.workNo,wageList,partList,program,0,0,function(result){
      
      if (result.data.discount_part>0||result.data.discount_wage>0) {
        displayDiscount = ""
        checkDiscount = true
      } else {
        displayDiscount = "none"
        checkDiscount = false
      }

      that.setState({loading:false,displayDiscount:displayDiscount,checkDiscount:checkDiscount})
    },function(error){
      that.setState({loading:false,errorShow:true})
    })

    that.setState({loading:true})
  }

  onConfirmSave(){
    this.setState({errorShow:false})
    this.onSaveClick()
  }

  onCloseClick(){
    window.show_work_table();
  }

  onMenuItemSelect(eventKey,event){
    // console.log("eventKey",eventKey,event)
    let docNameConst = {invoice:'ใบแจ้งหนี้',receipt:'ใบเสร็จรับเงิน',taxinvoice:'ใบกำกับภาษี',cashbill:'บิลเงินสด'}
    let {workNo} = this.props
    if("quotation"===eventKey){
      //window.request_quotation();
      if(this.state.fileId!=='')    
        this.setState({showQo:true})
        
    }else if(["invoice", "receipt", "tax_invoice", "cash_bill"].includes(eventKey)){
      //window.request_cash_bill();    
      //this.setState({showNewDoc:true})  
      var fn = window['request_'+eventKey];          
      if (typeof fn === 'function') {              
          fn.apply(undefined, []);
      } 
      // this.refs.newdoc.loadData({workNo:workNo,docType:eventKey,docName:docNameConst[eventKey],
      //   onRowClick:function(docNo){
      //   if (process.env.NODE_ENV == "development") {
      //     alert('show_cashbill_doc:'+docNo)
      //   }else{
      //     //window.show_cashbill_doc(docNo);
      //     var fn = window['show_'+eventKey+'_doc'];          
      //     if (typeof fn === 'function') {              
      //         fn.apply(undefined, [docNo]);
      //     } 

      //   }
      // },onNewDoc:function(filterType,priceOnListType){
      //   if (process.env.NODE_ENV == "development") {
      //     alert('onNewDoc:'+filterType+','+priceOnListType)
      //   }else{
      //     var fn = window['create_'+eventKey+'_doc'];          
      //     if (typeof fn === 'function') {              
      //         fn.apply(undefined, [workNo,filterType,priceOnListType]);
      //     }          
      //   }
      // }
      //})
    }else if("exportstock"===eventKey){ 
      // window.request_export_stock();

      let that = this
      WorkdocStore.loadWorkdocFixingList(this.props.workNo,function(result){

        let data = result.data.partlist.map((item,index)=>{
          item.description = item.detail
          return item
        })
        

        const yTh = parseInt(Moment().format('YYYY')) + 543
        const date = Moment().format('L LT').replace(Moment().format('YYYY'), yTh);
        let export_stock_flag = []
        data.forEach(element => {
          if (element.export_stock_flag=="1") {
            export_stock_flag.push({
              itemnum: element.itemnum
            })
          }
        })
        let displayBtnStockOutView = "none"
        let btnDisabled = false
        if (export_stock_flag.length>0) { // export_stock_flag.length==data.length
          displayBtnStockOutView = ""
        } 
        if (export_stock_flag.length==data.length) {
          displayBtnStockOutView = ""
          btnDisabled = true
        }
        that.setState({ createDate:date, showStockOut:true, dataStockOut:data, displayBtnStockOutView:displayBtnStockOutView, btnDisabled:btnDisabled })  

      })  
    }else if("purchaseorder"===eventKey){
      window.request_purchase();
    }
  }

  onStockOutDeleteClick(e) {
    let data = this.state.dataStockOut
    var key = ""

    for (var i = 0; i < this.state.dataStockOut.length; i++) {
      if (e == this.state.dataStockOut[i].itemnum) {
        key = i
      }
    }

    data.splice(key, 1)
    this.setState({ dataStockOut: data })
  }

  onStockOutCancelClick(e) {
    
  }  

  onStockOutCloseClick() {
    this.setState({ showStockOut: false })
  }

  onShowWageChange(value){
    this.setState({showWage:value})
  }

  onProgramChange(wageList,partList,program){
    this.setState({program:program})
    // this.refs.partDataGrid.addItems(partList)

    let {partFromList,damageCfg} = this.state
    wageList = this.refs.wageDataGrid.setWageList(wageList) // this.setWageList(wageList)
    if(damageCfg.part_from_list_visible){
      // console.log('program',wageList,partList)
      partFromList[0].partList = this.setPartList(partList)
      this.setState({partFromList:partFromList,loadingPart:false,loading:true})

      setTimeout(()=>{
        this.setState({loadingPart:true,loading:false})
      },500)
      //this.refs['partDataGrid-'+partFromList[0].name].getWrappedInstance().setPartList(this.setPartList(partList))
    }else{
      partList = this.refs.partDataGrid.setPartList(partList) // this.setPartList(partList)
    }
  }

  onSuccessExport(){
      this.loadData()
  }

  onTabSelect(index){
    let {history} = this.state
    this.setState({activeTab:index})

    if (index==history.length-1||index==0) {
      //this.setState({presentTab:index})      
    }

    let item = history[index]
    if(this.props.workNo !== item.work_no && item.htmlContent==''){
      this.setState({loading:true})
      let that = this
      
      WorkdocStore.loadWorkdocFixingListHtmlContent(item.work_no,function(result){
        history[index].htmlContent = result.data.htmlContent
        that.setState({loading:false,history:history})
      })
    }
  }

  renderDocMenu(){
    let {quotation_menu_visible} = this.state.damageCfg
    let title = (<span><i className="fa  fa-edit"></i>&nbsp;สร้างเอกสาร</span>)
    return (
      <div className="margin box-tools pull-right">
      <ButtonToolbar>
        <DropdownButton id='' bsStyle={'primary'} title={title}  onSelect={this.onMenuItemSelect.bind(this)}>          
          {quotation_menu_visible?<MenuItem eventKey="quotation"><FontAwsome name='file-text-o' className='text-green'/>ใบเสนอราคา</MenuItem>:''}
          <MenuItem eventKey="invoice"><FontAwsome name='file-text-o' className='text-green'/>ใบแจ้งหนี้</MenuItem>          
          <MenuItem eventKey="tax_invoice"><FontAwsome name='file-text-o' className='text-green'/>ใบกำกับภาษี</MenuItem>
          <MenuItem eventKey="cash_bill"><FontAwsome name='file-text-o' className='text-green'/>บิลเงินสด</MenuItem>
          <MenuItem divider />          
          <MenuItem eventKey="exportstock"><FontAwsome name='file-text-o' className='text-green'/>ใบเบิกคลังสินค้า</MenuItem>
        </DropdownButton>
      </ButtonToolbar>
      </div>
    )
  }

  renderDocMenu2(){
    return (
      <div className="margin box-tools pull-right">
        <div className="btn-group hide-when-done">
        <button type="button" className="btn btn-primary "><i className="fa  fa-edit"></i>&nbsp;สร้างเอกสาร</button>
        <button type="button" className="btn btn-primary dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
        <span className="caret"></span>
        <span className="sr-only">Toggle Dropdown</span>
        </button>
        <ul className="dropdown-menu" role="menu">
        <li aria-disabled="true"><a href="#new_doc_quotation"><i className="fa  fa-file-text-o text-green"></i>ใบเสนอราคา</a></li>
        <li aria-disabled="true"><a href="#new_doc_invoice"><i className="fa  fa-file-text-o text-green"></i>ใบแจ้งหนี้</a></li>
        <li aria-disabled="true"><a href="#new_doc_receipt"><i className="fa  fa-file-text-o text-green"></i>ใบเสร็จรับเงิน</a></li>
        <li aria-disabled="true"><a href="#new_doc_tax_invoice"><i className="fa  fa-file-text-o text-green"></i>ใบกำกับภาษี</a></li>
        <li aria-disabled="true"><a href="#new_doc_cash_bill"><i className="fa  fa-file-text-o text-green"></i>บิลเงินสด</a></li>
        <li aria-disabled="true"><a href="#new_doc_export_stock"><i className="fa  fa-file-text-o text-green"></i>ใบเบิกคลังสินค้า</a></li>
        </ul>
        </div>
      </div>
    )
  }
  /*================================================*/
  summaryAmountPart(){
    let {dataPartlist} = this.state

    // let sum = 0;
    //  dataPartlist.map((item,index)=>{
    //     sum += item.amount*1
    // })

    let sumRow = 0
    let sum = 0
    let quantity = 0
    let pricePerUnit = 0
    let discountAmount = 0
    dataPartlist.forEach(function(item,index) {
      if (item.quantity==0||isNaN(item.quantity)==true) {
        quantity = 0
      } else {
        quantity = item.quantity
      }

      if (item.pricePerUnit==0||isNaN(item.pricePerUnit)==true) {
        pricePerUnit = 0
      } else {
        pricePerUnit = item.pricePerUnit
      }

      if (item.discountAmount<=0||isNaN(item.discountAmount)==true) {
        discountAmount = 0
      } else {
        discountAmount = item.discountAmount
      }

      sumRow = (quantity*pricePerUnit)-discountAmount
      sum = parseFloat(sum) + parseFloat(sumRow) 
    })
    
    return sum
  }

  summaryAmountWage(){
    let {dataWagelist} = this.state

    let sumRow = 0
    let sum = 0
    let quantity = 0
    let pricePerUnit = 0
    let discountAmount = 0
    dataWagelist.forEach(function(item,index) {
      if (item.quantity==0||isNaN(item.quantity)==true) {
        quantity = 0
      } else {
        quantity = item.quantity
      }

      if (item.pricePerUnit==0||isNaN(item.pricePerUnit)==true) {
        pricePerUnit = 0
      } else {
        pricePerUnit = item.pricePerUnit
      }

      if (item.discountAmount<=0||isNaN(item.discountAmount)==true) {
        discountAmount = 0
      } else {
        discountAmount = item.discountAmount
      }

      sumRow = (quantity*pricePerUnit)-discountAmount
      sum = parseFloat(sum) + parseFloat(sumRow) 
    })
    
    return sum
  }

  onWageDataChange(data){
    this.setState({dataWagelist:data})
    this.getDiscountWage()
  }

  onPartDataChange(data){
    this.setState({dataPartlist:data})
    this.getDiscountPart()
  }

  getDiscountPart() {
    let {discountPart,curDiscountPart,dataPartlist} = this.state
    let sumAmount = 0
    let discount = 0
    sumAmount = this.summaryAmountPart()

    let discount_table = 0
    dataPartlist.forEach(function(item,index) {
      // discount_table = parseFloat(discount_table)+parseFloat(item.discountAmount)
      let discountAmount = 0
      if (item.discountAmount<=0||isNaN(item.discountAmount)==true) {
        discountAmount = 0
      } else {
        discountAmount = item.discountAmount
      }
      discount_table = parseFloat(discount_table)+parseFloat(discountAmount)
    })
    curDiscountPart = discountPart

    if (discount_table>0) { 
      discount = (discount_table / sumAmount) * 100
      if (discount%1 != 0) {
        discount = discount.toFixed(2)
      }
      discountPart[0] = discount
      discountPart[1] = discount_table
    } else {
      // discount = (sumAmount / 100) * discountPart[0]
      // if (discount%1 != 0) {
      //   discount = discount.toFixed(2)
      // }
      // if (discountPart[1]>0) {
      //   discountPart[1] = discountPart[1]
      //   discount = (discountPart[1] / sumAmount) * 100
      //   if (discount%1 != 0) {
      //     discount = discount.toFixed(2)
      //   }
      //   discountPart[0] = discount
      // } else {
      //   discountPart[1] = discount
      // } 

      // discountPart[0] = curDiscountPart[0]
      // discountPart[1] = curDiscountPart[1]
      discountPart[0] = 0
      discountPart[1] = ''
    }
    this.checkSumDiscountOpen()
    this.setState({discountPart:discountPart})
  }

  getDiscountWage() {
    let {discountWage,curDiscountWage,dataWagelist} = this.state
    let sumAmount = 0
    let discount = 0
    sumAmount = this.summaryAmountWage()

    let discount_table = 0
    dataWagelist.forEach(function(item,index) {
      // discount_table = parseFloat(discount_table)+parseFloat(item.discountAmount)
      let discountAmount = 0
      if (item.discountAmount<=0||isNaN(item.discountAmount)==true) {
        discountAmount = 0
      } else {
        discountAmount = item.discountAmount
      }
      discount_table = parseFloat(discount_table)+parseFloat(discountAmount)
    })
    curDiscountWage = discountWage

    if (discount_table>0) { 
      discount = (discount_table / sumAmount) * 100
      if (discount%1 != 0) {
        discount = discount.toFixed(2)
      }
      discountWage[0] = discount
      discountWage[1] = discount_table
    } else {
      // discount = (sumAmount / 100) * discountWage[0]
      // if (discount%1 != 0) {
      //   discount = discount.toFixed(2)
      // }
      // if (discountWage[1]>0) {
      //   discountWage[1] = discountWage[1]
      //   discount = (discountWage[1] / sumAmount) * 100
      //   if (discount%1 != 0) {
      //     discount = discount.toFixed(2)
      //   }
      //   discountWage[0] = discount
      // } else {
      //   discountWage[1] = discount
      // }

      // discountWage[0] = curDiscountWage[0]
      // discountWage[1] = curDiscountWage[1]
      discountWage[0] = 0
      discountWage[1] = ''
    }  
    this.checkSumDiscountOpen()
    this.setState({discountWage:discountWage})
  }

  checkSumDiscountOpen() {
    let {dataPartlist,dataWagelist} = this.state

    let discountWage_table = 0
    dataWagelist.forEach(function(item,index) {
      let discountAmount = 0
      if (item.discountAmount<=0||isNaN(item.discountAmount)==true) {
        discountAmount = 0
      } else {
        discountAmount = item.discountAmount
      }
      discountWage_table = parseFloat(discountWage_table)+parseFloat(discountAmount)
    })

    let discountPart_table = 0
    dataPartlist.forEach(function(item,index) {
      let discountAmount = 0
      if (item.discountAmount<=0||isNaN(item.discountAmount)==true) {
        discountAmount = 0
      } else {
        discountAmount = item.discountAmount
      }
      discountPart_table = parseFloat(discountPart_table)+parseFloat(discountAmount)
    })

    if (discountWage_table>0||discountPart_table>0) {
      this.setState({displayDiscount:"",checkDiscount:true})
    } else {
      this.setState({displayDiscount:"none",checkDiscount:false})
    }
  }

  onDiscountPercentChange(table,e) {
    let {discountPart,discountWage,dataPartlist,dataWagelist} = this.state
    let sumAmount = 0
    let discount = 0
    let value = 0

    if (table=='wage') {
      sumAmount = this.summaryAmountWage()
      let discountWage_table = 0
      dataWagelist.forEach(function(item,index) {
        // discountWage_table = parseFloat(discountWage_table)+parseFloat(item.discountAmount)
        let discountAmount = 0
        if (item.discountAmount<=0||isNaN(item.discountAmount)==true) {
          discountAmount = 0
        } else {
          discountAmount = item.discountAmount
        }
        discountWage_table = parseFloat(discountWage_table)+parseFloat(discountAmount)
      })
      if (discountWage_table>0) {
        this.setState({discountShow:true})
        discountWage[0] = discountWage[0]
        discountWage[1] = discountWage[1]
        this.setState({discountWage:discountWage})
      } else {
        if (e.target.value<=0||isNaN(e.target.value)==true) {
          discount = 0
          if (e.target.value=='') {
            value = ''
          }
        } else {   
          value = e.target.value
          discount = (sumAmount / 100) * e.target.value
          if (discount%1 != 0) {
            discount = discount.toFixed(2)
          }
        }
        discountWage[0] = value
        discountWage[1] = discount
        this.setState({discountWage:discountWage})
      }  
    } else if (table=='part') {
      sumAmount = this.summaryAmountPart()
      let discountPart_table = 0
      dataPartlist.forEach(function(item,index) {
        // discountPart_table = parseFloat(discountPart_table)+parseFloat(item.discountAmount)
        let discountAmount = 0
        if (item.discountAmount<=0||isNaN(item.discountAmount)==true) {
          discountAmount = 0
        } else {
          discountAmount = item.discountAmount
        }
        discountPart_table = parseFloat(discountPart_table)+parseFloat(discountAmount)
      })
      if (discountPart_table>0) {
        this.setState({discountShow:true})
        discountPart[0] = discountPart[0]
        discountPart[1] = discountPart[1]
        this.setState({discountPart:discountPart})
      } else {
        if (e.target.value<=0||isNaN(e.target.value)==true) {
          discount = 0
          if (e.target.value=='') {
            value = ''
          }
        } else {   
          value = e.target.value
          discount = (sumAmount / 100) * e.target.value
          if (discount%1 != 0) {
            discount = discount.toFixed(2)
          }
        }
        discountPart[0] = value
        discountPart[1] = discount
        this.setState({discountPart:discountPart})
      }
    }    
  }

  onDiscountAmountChange(table,e) {
    let {discountPart,discountWage,dataPartlist,dataWagelist} = this.state
    let sumAmount = 0
    let discount = 0
    let value = 0

    if (table=='wage') {
      sumAmount = this.summaryAmountWage()
      let discountWage_table = 0
      dataWagelist.forEach(function(item,index) {
        // discountWage_table = parseFloat(discountWage_table)+parseFloat(item.discountAmount)
        let discountAmount = 0
        if (item.discountAmount<=0||isNaN(item.discountAmount)==true) {
          discountAmount = 0
        } else {
          discountAmount = item.discountAmount
        }
        discountWage_table = parseFloat(discountWage_table)+parseFloat(discountAmount)
      })
      if (discountWage_table>0) {
        this.setState({discountShow:true})
        discountWage[0] = discountWage[0]
        discountWage[1] = discountWage[1]
        this.setState({discountWage:discountWage})
      } else {
        if (e.target.value<=0||isNaN(e.target.value)==true) {
          discount = 0
          if (e.target.value=='') {
            value = ''
          }
        } else {   
          value = e.target.value
          discount = (e.target.value / sumAmount) * 100
          if (discount%1 != 0) {
            discount = discount.toFixed(2)
          }
        }
        discountWage[0] = discount
        discountWage[1] = value
        this.setState({discountWage:discountWage})
      }  
    } else if (table=='part') {
      sumAmount = this.summaryAmountPart()
      let discountPart_table = 0
      dataPartlist.forEach(function(item,index) {
        // discountPart_table = parseFloat(discountPart_table)+parseFloat(item.discountAmount)
        let discountAmount = 0
        if (item.discountAmount<=0||isNaN(item.discountAmount)==true) {
          discountAmount = 0
        } else {
          discountAmount = item.discountAmount
        }
        discountPart_table = parseFloat(discountPart_table)+parseFloat(discountAmount)
      })
      if (discountPart_table>0) {
        this.setState({discountShow:true})
        discountPart[0] = discountPart[0]
        discountPart[1] = discountPart[1]
        this.setState({discountPart:discountPart})
      } else {
        if (e.target.value<=0||isNaN(e.target.value)==true) {
          discount = 0
          if (e.target.value=='') {
            value = ''
          }
        } else {   
          value = e.target.value
          discount = (e.target.value / sumAmount) * 100
          if (discount%1 != 0) {
            discount = discount.toFixed(2)
          }
        }
        discountPart[0] = discount
        discountPart[1] = value
        this.setState({discountPart:discountPart})
      }
    }
  }

  getTotal() {
    let {discountPart,discountWage} = this.state
    let part = discountPart[1]
    let wage = discountWage[1]
    let sumAmountWage = 0
    let sumAmountPart = 0
    let total = 0
    sumAmountWage = this.summaryAmountWage() - wage
    sumAmountPart = this.summaryAmountPart() - part
    total = parseFloat(sumAmountWage) + parseFloat(sumAmountPart)
    return total
  }

  onCheckDiscountChange(e) {
    let {checkDiscount,displayDiscount,discountPart,discountWage,curDiscountPart,curDiscountWage} = this.state
    if (checkDiscount) {
      checkDiscount = false
      displayDiscount = "none"
      curDiscountPart = discountPart
      curDiscountWage = discountWage
      discountPart = [0,'']
      discountWage = [0,'']
    } else {
      checkDiscount = true
      displayDiscount = ""
      discountPart = curDiscountPart
      discountWage = curDiscountWage
      // discountPart = [0,'']
      // discountWage = [0,'']
    }
    this.setState({checkDiscount:checkDiscount,displayDiscount:displayDiscount,curDiscountPart:curDiscountPart,curDiscountWage:curDiscountWage,discountPart:discountPart,discountWage:discountWage})
  }

  renderSummary() {
    let {discountPart,discountWage,discount_wage,discount_part} = this.state

    return (
      <div>
        <Col md={8}></Col>
        <Col md={4} className="">
          <div className="">
            <table className='table table-doc-summary'>
                <tbody>
                  <tr>
                    <td className="text-right"></td>
                    <td className="text-right" style={{width:'150px'}}>จำนวนเงินค่าแรง</td>
                    <td className="text-right" style={{width:'150px'}}>{this.summaryAmountWage().toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")}&nbsp;&nbsp;&nbsp;บาท</td>
                  </tr>
                  <tr>
                    <td className="text-right"></td>
                    <td className="text-right" style={{width:'150px'}}>จำนวนเงินค่าอะไหล่</td>
                    <td className="text-right" style={{width:'150px'}}>{this.summaryAmountPart().toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")}&nbsp;&nbsp;&nbsp;บาท</td>
                  </tr>
                  <tr>
                    <td className="text-right"></td>
                    <td className="text-right" style={{width:'150px'}}>
                      <FormGroup>
                        <InputGroup>
                          <InputGroup.Addon style={{border:'none',color:'#333',fontSize:'16px',paddingLeft:'30px'}}>ส่วนลดค่าแรง</InputGroup.Addon>
                          <FormControl 
                            style={{borderRadius:'0',right:'5px',width:'80px'}}
                            type="text" 
                            className='text-right input-right'
                            value={discountWage[0]}
                            onChange={this.onDiscountPercentChange.bind(this,'wage')}
                          />
                          <InputGroup.Addon style={{padding:'0',border:'none',backgroundColor:'inherit',color:'#333',fontSize:'16px'}}>%</InputGroup.Addon>
                        </InputGroup>
                      </FormGroup>
                    </td>
                    <td className="text-right" style={{width:'150px'}}>
                      <FormGroup>
                        <InputGroup>
                          <FormControl 
                            style={{borderRadius:'0',right:'5px'}}
                            type="text" 
                            placeholder="x,xxx"
                            className='text-right'
                            value={discountWage[1]}
                            onChange={this.onDiscountAmountChange.bind(this,'wage')}
                          />
                          <InputGroup.Addon style={{padding:'0',border:'none',backgroundColor:'inherit',color:'#333',fontSize:'16px'}}>บาท</InputGroup.Addon>
                        </InputGroup>
                      </FormGroup>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-right"></td>
                    <td className="text-right" style={{width:'150px'}}>
                      <FormGroup>
                        <InputGroup>
                          <InputGroup.Addon style={{border:'none',color:'#333',fontSize:'16px'}}>ส่วนลดค่าอะไหล่</InputGroup.Addon>
                          <FormControl 
                            style={{borderRadius:'0',right:'5px',width:'80px'}}
                            type="text" 
                            className='text-right input-right'
                            value={discountPart[0]}
                            onChange={this.onDiscountPercentChange.bind(this,'part')}
                          />
                          <InputGroup.Addon style={{padding:'0',border:'none',backgroundColor:'inherit',color:'#333',fontSize:'16px'}}>%</InputGroup.Addon>
                        </InputGroup>
                      </FormGroup>
                    </td>
                    <td className="text-right" style={{width:'150px'}}>
                      <FormGroup>
                        <InputGroup>
                          <FormControl 
                            style={{borderRadius:'0',right:'5px'}}
                            type="text" 
                            placeholder="x,xxx"
                            className='text-right'
                            value={discountPart[1]}
                            onChange={this.onDiscountAmountChange.bind(this,'part')}
                          />
                          <InputGroup.Addon style={{padding:'0',border:'none',backgroundColor:'inherit',color:'#333',fontSize:'16px'}}>บาท</InputGroup.Addon>
                        </InputGroup>
                      </FormGroup>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-right"></td>
                    <td className="text-right" style={{width:'150px'}}>ยอดรวมหลังหักส่วนลด</td>
                    <td className="text-right" style={{width:'150px'}}>{this.getTotal().toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")}&nbsp;&nbsp;&nbsp;บาท</td>
                  </tr>
                  <tr>
                    <td className="text-right"></td>
                    <td className="bbr-b text-right" style={{width:'150px'}}><b>ยอดรวมสุทธิ</b></td>
                    <td className="bbr-b text-right" style={{width:'150px'}}>{this.getTotal().toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")}&nbsp;&nbsp;&nbsp;บาท</td>
                  </tr>
                </tbody>
              </table>
          </div>    
        </Col>
    </div>    
    )
  }

  renderPresentWork(){
    let {loading} = this.state
    return (        
      <Box loading={loading}>
        <Box.Header>
          <Box.Title><FontAwsome name='warning' className='text-blue'/>&nbsp;รายการซ่อม/เปลี่ยน</Box.Title>
          {/*{this.renderDocMenu()}*/}
          {this.renderPresentWorkDocMenu()}
        </Box.Header>
        {this.renderPresentWorkBody()}        
        <Box.Footer>
          <div className='pull-right'>
                <div style={{display:'none'}}>
                      <Checkbox
                        onChange={this.onCheckDiscountChange.bind(this)}
                        checked={this.state.checkDiscount}
                        checkboxClass="icheckbox_square-blue"
                        increaseArea="20%"
                        label=" มีส่วนลด"
                      >
                      </Checkbox>
              </div>
                      &nbsp;
              <Button bsStyle={'primary'} 
                className='hide-when-done element-ready'
                onClick={this.onSaveClick.bind(this)}
              >
                <FontAwsome name='save'/>&nbsp;บันทึก
              </Button>
              &nbsp;
              <Button onClick={this.onCloseClick.bind(this)}><FontAwsome name='close'/>&nbsp;ปิดใบงาน</Button>            
          </div> 
        </Box.Footer>
      </Box>
    )
  }

  renderPresentWorkDocMenu() {
    let {presentTab,history} = this.state
    // console.log("length-1",history.length-1)
    // console.log("presentTab",presentTab)
    if (presentTab!=history.length-1) {
      return (
        this.renderDocMenu()
      )  
    }  
  }

  renderWageTable(){
    let {showWage,program,damageCfg,presentTab,activeTab,history} = this.state
    let {workNo} = this.props
    
    return (
      <div>
        <div>
              <h4 className='text-center'><span style={{display:showWage?'inline-block':'none'}}>สรุปรายการค่าแรง </span>
                <div className='pull-right'>
                  <Checkbox 
                    checkboxClass="icheckbox_square-blue"
                    increaseArea="20%"
                    label="ซ่อนรายการค่าแรง"
                    checked={!showWage}
                    onChange={this.onShowWageChange.bind(this,!showWage)}
                  />
                </div>
              </h4>
            </div>
            <div style={{display:showWage?'block':'none'}}>
              <SWTWageDataGrid 
                ref={'wageDataGrid'} 
                showDiscount={damageCfg.discount_visible}
                showQuantity={damageCfg.wage_quantity_visible} 
                // showProgramButton={damageCfg.program_visible} 
                // onProgramChange={this.onProgramChange.bind(this)}
                onChange={this.onWageDataChange.bind(this)}
              />
            </div>
      </div>
    )
  }

  

  renderPartTable(){
    let {showWage,program,damageCfg,presentTab,activeTab,history} = this.state
    let {workNo} = this.props
    
    return (
      <div>
        <h4 className='text-center'>สรุปรายการค่าอะไหล่ </h4>
            <SWTPartDataGrid 
              ref={'partDataGrid'}
              showDiscount={damageCfg.discount_visible}
              showCostPerUnit={damageCfg.part_cost_per_unit_visible}
              showProgramButton={damageCfg.program_visible}
              onProgramChange={this.onProgramChange.bind(this)}
              onChange={this.onPartDataChange.bind(this)}
              workNo={this.props.workNo}
            />
      </div>
    )
  }

  renderPresentWorkBody() {
    let {showWage,program,damageCfg,presentTab,activeTab,history} = this.state
    let {workNo} = this.props
    
    if (damageCfg.part_first) {
      return(
          <Box.Body>

            {this.renderPartTable()}
            {this.renderWageTable()}
            <Row style={{display:this.state.displayDiscount}}>
              {this.renderSummary()}
            </Row>
            
          </Box.Body>
      )
    } else {
      return(
          <Box.Body>
            {this.renderWageTable()}
            {this.renderPartTable()}
            <Row style={{display:this.state.displayDiscount}}>
              {this.renderSummary()}
            </Row>
          </Box.Body>
      )
    }  
  }

  renderPastWork(){
    let {history,activeTab,presentTab,loading} = this.state
    
    let item = history[activeTab]
    if(presentTab!==activeTab){
    return (
      <Box loading={loading}>
        <Box.Header>
          <Box.Title><FontAwsome name='warning' className='text-blue'/>&nbsp;เลขกม. {item.mileage} รายการซ่อม</Box.Title>          
        </Box.Header>
        <Box.Body>
          <div>
            <Panel style={{marginBottom:'0px'}}><div dangerouslySetInnerHTML={{__html:history[activeTab].htmlContent}}></div></Panel>
          </div>        
        </Box.Body>
      </Box>
    )  
    }else{
      return (<div/>)
    }  
    
  }

  renderNavItem(item,index){
    if(item.work_no===this.props.workNo){
      return (<NavItem key={index} eventKey={index} >รายการใบงานนี้</NavItem>)
    }else{
      return (<NavItem key={index} eventKey={index} >{item.work_date}</NavItem>)
    }
  }

  renderHistoryTab(history){
    let {activeTab} = this.state
    return (
      <Nav bsStyle="tabs" activeKey={activeTab} onSelect={this.onTabSelect.bind(this)}>   
        <NavItem key={history.length-1} eventKey={history.length-1} style={{display:'none'}}>แจ้งซ่อมล่วงหน้า</NavItem>     
        {history.map((item,index)=>(
          this.renderNavItem(item,index)
        ))}
      </Nav>
    )
  }

  render(){
    let {history,errorShow,showNewDoc,activeTab,presentTab,discountShow} = this.state
    let {showQo,fileId,fileName} = this.state
    return (
      <div>
        <div style={{display:(history.length>0)?'block':'none'}}>
          {this.renderHistoryTab(history)}
        </div>
        <div style={{display:(activeTab==presentTab)?'block':'none'}}>
          {this.renderPresentWork()}
        </div>
        <div style={{display:(activeTab!==presentTab)?'block':'none'}}>
          {this.renderPastWork()}
        </div>
       
        <ConfirmPopup show={errorShow} 
        title='มีปัญหาในการบันทึกข้อมูล' 
        message='พบปัญหาอินเตอร์เน็ต ไม่สามารถบันทึกข้อมูลได้ กรุณาลองใหม่'
        confirmTitle='ลองใหม่อีกครั้ง'
        onConfirm={this.onConfirmSave.bind(this)}
        onHide={()=>{this.setState({errorShow:false})}}        
        />
        <ConfirmPopup show={discountShow} 
        title='แจ้งเตือน'
        message='ท่านได้ใส่ข้อมูลส่วนลดค่าแรงในตาราง เรียบร้อยแล้ว ถ้าต้องการแก้ไขข้อมูล ให้ลบส่วนลดในตาราง'
        onHide={()=>{this.setState({discountShow:false})}}        
        />
         
        <SWTStockOutPopup
          stockType={'genpart'}
          onShow={this.state.showStockOut}
          onHide={this.onStockOutCloseClick.bind(this)}
          onDelete={this.onStockOutDeleteClick.bind(this)}
          onCancel={this.onStockOutCancelClick.bind(this)}
          onSuccessExport={this.onSuccessExport.bind(this)}
          data={this.state.dataStockOut}
          date={this.state.createDate}
          workNo={this.props.workNo}
          displayBtnStockOutView={this.state.displayBtnStockOutView}
          btnDisabled={this.state.btnDisabled}
        />
        <QuotationDocModal 
            show={showQo} 
            fileId={fileId}
            fileName={fileName}
            onHide={()=>{this.setState({showQo:false})}}/>
      </div>
    )
  }
}


export default SWTWorkDocDamage;





// WEBPACK FOOTER //
// ./src/view/workdoc/SWTWorkDocDamage.js